export enum ComponentType {
  TextArea = "textArea",
  ToneOfVoice = "toneOfVoice",
}

export enum TemplateCategory {
  All = "All",
  SocialMedia = "Social Media",
  Email = "Email",
  Website = "Website",
  Sales = "Sales",
  Support = "Support",
  Writing = "Writing",
  Education = "Education",
  Marketing = "Marketing",
  Legal = "Legal",
  Business = "Business",
  TrainingMaterial = "Training Material",
}

const TemplateCategoryArray = [
  "Social Media",
  "Email",
  "Website",
  "Sales",
  "Support",
  "Writing",
  "Education",
  "Marketing",
  "Legal",
  "Business",
  "Training Material",
];
export interface Field {
  type: ComponentType;
  label: string;
  field: string;
  optional?: boolean;
  required?: boolean;
  description?: string;
  placeholder?: string;
}

export interface BaseTemplate {
  name: string;
  shortDescription: string;
  id: string;
  slug: string;
  fields: Field[];
  category: TemplateCategory[];
  freeLimit: number;
  buildUserPrompt: (fields: Record<string, string>) => string;
  buildSystemPrompt: () => string;
}
